import { atom } from 'jotai';

export type MapDataLayerPopupProps = {
  title: string;
  properties: any;
  lngLat: [number, number];
  mapDataId?: number;
  sourceLayer?: string;
  featureId?: any;
};

export const mapDataLayerPopupPropsAtom = atom<MapDataLayerPopupProps | null>(null);